module.exports = __webpack_public_path__ + "img/whats-new-22_en.d23319a.jpg";